/* =========================================================================
   Custom Product Badges (Flairのバッジ機能を再現・コード版)
   -------------------------------------------------------------------------
   ・KIMONO-CYCLE様のFlair設定（Badges画面）の内容をもとに、同じ11個の
     バッジをコードで再現しています。
   ・商品一覧ページ・商品詳細ページ・TOPページ「Featured product」セクション等、
     どこでも「商品名」と「価格」の間に表示します
     （テーマに既にある <flair-badges> タグと同じ位置。data-handle属性で商品を特定）。
     公開JSON ( /products/{handle}.js ) を取得して条件判定します。
   ・ルールは下記 BADGE_RULES の配列を編集するだけで追加・変更・削除できます。
   ========================================================================= */
(function () {
  "use strict";

  /* ===================== 共通設定 ===================== */
  var SETTINGS = {
    maxBadges: 3,
    // 商品カード内でバッジを差し込む場所を探すためのセレクタ。
    // 1つ目: テーマに既にある <flair-badges> タグ（product-grid-item.liquidに存在）
    // 2つ目以降: 見つからない場合のフォールバック（商品名の直後）
    badgeSlotSelector: "flair-badges",
    titleFallbackSelector: ".grid-product__title, .product-item__title, .product-card__title",
    gridLinkSelector: 'a[href*="/products/"]'
  };

  /* ===================== バッジのルール一覧 ===================== */
  /*
    conditions で使える項目:
      tag          : このタグを持つ商品に表示 (例: "L")
      handles      : この商品ハンドルの配列に含まれる商品にのみ表示
      newWithinDays: 商品登録からNN日以内なら表示
      requireInStock: true にすると在庫がある場合のみ表示（Flairの「Inventory is in stock」相当）

    bg / color でバッジの背景色・文字色を指定します。
  */
  var BADGE_RULES = [
    {
      id: "new",
      label: "NEW",
      bg: "#3498DB",
      color: "#ffffff",
      conditions: { newWithinDays: 20, requireInStock: true }
    },
    {
      id: "size-s",
      label: "S",
      bg: "#182E49",
      color: "#ffffff",
      conditions: { tag: "S", requireInStock: true }
    },
    {
      id: "size-m",
      label: "M",
      bg: "#182E49",
      color: "#ffffff",
      conditions: { tag: "M", requireInStock: true }
    },
    {
      id: "size-l",
      label: "L",
      bg: "#182E49",
      color: "#ffffff",
      conditions: { tag: "L", requireInStock: true }
    },
    {
      id: "size-xl",
      label: "XL",
      bg: "#182E49",
      color: "#ffffff",
      conditions: { tag: "XL", requireInStock: true }
    },
    {
      id: "size-xxl",
      label: "XXL",
      bg: "#182E49",
      color: "#ffffff",
      conditions: { tag: "XXL", requireInStock: true }
    },
    {
      id: "size-xs",
      label: "XS",
      bg: "#182E49",
      color: "#ffffff",
      conditions: { tag: "XS", requireInStock: true }
    },
    {
      id: "nagasode",
      label: "長袖",
      bg: "#662B04",
      color: "#ffffff",
      conditions: { handles: ["長袖紬シャツtm100005", "紬シャツ-長袖-tm100009", "紬シャツ-長袖-tm100011"] }
    },
    {
      id: "womens",
      label: "Women's",
      bg: "#DB2777",
      color: "#ffffff",
      conditions: { tag: "レディース" }
    },
    {
      id: "ordermade",
      label: "オーダーメイド",
      bg: "#3498DB",
      color: "#ffffff",
      conditions: { tag: "オーダーメイド" }
    },
    {
      id: "kimono-aloha",
      label: "自分の着物をアロハに！",
      bg: "#182E49",
      color: "#ffffff",
      conditions: { handles: ["alohashirt-order"] }
    }
  ];
  /* ===================== ここまで設定 ===================== */

  /* ===== 英語ロケール用のバッジラベル（BADGE_RULESの外に置く） =====
     ※ BADGE_RULES はバッジ管理ツールが丸ごと書き換えるため、
       英語対応は必ずこの外側に置くこと。 */
  var BADGE_LABELS_EN = {
    "nagasode": "Long Sleeve",
    "ordermade": "Made to Order",
    "kimono-aloha": "Upcycle Your Own Kimono"
  };

  function isEnglishLocale() {
    var lang = (document.documentElement.getAttribute("lang") || "").toLowerCase();
    return lang.indexOf("en") === 0;
  }

  function badgeLabel(rule) {
    if (isEnglishLocale() && BADGE_LABELS_EN[rule.id]) {
      return BADGE_LABELS_EN[rule.id];
    }
    return rule.label;
  }

  var processed = new WeakSet();     // 処理済みの差し込み先要素
  var productCache = {};             // handle -> Promise<productJSON>

  function getHandleFromPath(pathname) {
    var m = pathname.match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function fetchProduct(handle) {
    if (productCache[handle]) return productCache[handle];
    productCache[handle] = fetch("/products/" + handle + ".js", { credentials: "same-origin" })
      .then(function (res) { return res.ok ? res.json() : null; })
      .catch(function () { return null; });
    return productCache[handle];
  }

  function daysSince(dateStr) {
    var created = new Date(dateStr).getTime();
    if (isNaN(created)) return Infinity;
    return (Date.now() - created) / (1000 * 60 * 60 * 24);
  }

  function hasTag(product, tag) {
    var tags = (product.tags || []).map(function (t) { return String(t).trim().toLowerCase(); });
    return tags.indexOf(String(tag).trim().toLowerCase()) !== -1;
  }

  function evaluateRule(rule, product, handle) {
    var c = rule.conditions || {};

    if (c.handles && c.handles.indexOf(handle) === -1) return false;
    if (c.tag && !hasTag(product, c.tag)) return false;
    if (c.newWithinDays && daysSince(product.created_at) > c.newWithinDays) return false;
    if (c.requireInStock && product.available === false) return false;

    // 何も条件が無いルールは誤爆防止のため非表示にする
    if (!c.handles && !c.tag && !c.newWithinDays) return false;

    return true;
  }

  function buildBadgeList(product, handle) {
    var badges = [];
    for (var i = 0; i < BADGE_RULES.length && badges.length < SETTINGS.maxBadges; i++) {
      var rule = BADGE_RULES[i];
      if (evaluateRule(rule, product, handle)) {
        badges.push(rule);
      }
    }
    return badges;
  }

  // 商品カードの中から「商品名と価格の間」に差し込む場所を探す。
  // 1) 既にある <flair-badges> タグがあればそれを使う
  // 2) 無ければ商品名の要素を探し、その直後に差し込む
  function findBadgeSlot(cardRoot) {
    var slot = cardRoot.querySelector(SETTINGS.badgeSlotSelector);
    if (slot) return slot;

    var title = cardRoot.querySelector(SETTINGS.titleFallbackSelector);
    if (title) {
      var placeholder = document.createElement("flair-badges");
      title.insertAdjacentElement("afterend", placeholder);
      return placeholder;
    }
    return null;
  }

  function renderBadges(slotEl, badges) {
    slotEl.innerHTML = "";
    if (!badges.length) return;

    var wrap = document.createElement("div");
    wrap.className = "cb-badge-row";

    badges.forEach(function (rule) {
      var span = document.createElement("span");
      span.className = "cb-badge";
      span.textContent = badgeLabel(rule);
      span.style.backgroundColor = rule.bg;
      span.style.color = rule.color;
      wrap.appendChild(span);
    });

    slotEl.appendChild(wrap);
  }

  function processCard(anchorEl, handle) {
    if (processed.has(anchorEl)) return;
    processed.add(anchorEl);
    fetchProduct(handle).then(function (product) {
      if (!product) return;
      var slot = findBadgeSlot(anchorEl);
      if (!slot) return;
      var badges = buildBadgeList(product, handle);
      renderBadges(slot, badges);
    });
  }

  function scanGrid(root) {
    var scope = root || document;
    var links = scope.querySelectorAll(SETTINGS.gridLinkSelector);
    links.forEach(function (a) {
      if (processed.has(a)) return;
      var handle = getHandleFromPath(a.getAttribute("href") || "");
      if (!handle) return;
      // 商品名・価格・<flair-badges>がすべて内包されているカード全体（<a>）を対象にする
      processCard(a, handle);
    });
  }

  // 商品一覧グリッド以外の場所にある <flair-badges> タグに対応
  // （商品詳細ページ、TOPページの「Featured product」セクションなど）。
  // タグ自身が持つ data-handle 属性から商品を特定するため、URLに依存しません。
  function getHandleForSlot(slot) {
    var attr = slot.getAttribute("data-handle");
    if (attr) return decodeURIComponent(attr);
    // 念のためのフォールバック（data-handle未設定の場合はURLから推測）
    return getHandleFromPath(window.location.pathname);
  }

  function scanStandaloneSlots(root) {
    var scope = root || document;
    var slots = scope.querySelectorAll(SETTINGS.badgeSlotSelector);
    slots.forEach(function (slot) {
      if (processed.has(slot)) return;
      // 商品一覧グリッドのカード内にあるものは scanGrid 側で処理済みなので除外
      if (slot.closest(SETTINGS.gridLinkSelector)) return;

      var handle = getHandleForSlot(slot);
      if (!handle) return;
      processed.add(slot);

      fetchProduct(handle).then(function (product) {
        if (!product) return;
        var badges = buildBadgeList(product, handle);
        renderBadges(slot, badges);
      });
    });
  }

  function init() {
    scanGrid(document);
    scanStandaloneSlots(document);

    // 無限スクロール・絞り込みフィルタなどで後から追加される商品カードに対応
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            scanGrid(node);
            scanStandaloneSlots(node);
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
